import { render, staticRenderFns } from "./transformative.vue?vue&type=template&id=66428ad2&scoped=true&"
import script from "./transformative.vue?vue&type=script&lang=js&"
export * from "./transformative.vue?vue&type=script&lang=js&"
import style0 from "./transformative.vue?vue&type=style&index=0&id=66428ad2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66428ad2",
  null
  
)

export default component.exports